import React from "react";
import { PERMISSION_ACTIONS, PERMISSION_MODULES } from "common/constants/PermissionConstants";
import CommonButton from "Components/Common/CommonButton";
import CommonStatusBadge from "Components/Common/CommonStatusBadge";
import { formatDate, formatTime24Hour } from "common/service/CommonService";
import { SubjectRow } from "./subjectcheckout.types";
import ip from "../../../Pharmacy/IPinventory/css/ipInventory.module.scss";

export const CheckOutColumns = (openCheckout: any, canassign: boolean): any[] => [
    {
        key: "subjectNo",
        label: "SUBJECT DETAILS",
        render: (_: any, row?: SubjectRow) => {
            if (!row) return <></>;
            return (
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <div
                        style={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            background: "#f1f5f9",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 12,
                            fontWeight: 600,
                            color: "#64748b",
                        }}
                    >
                        {row.subjectNo || "-"}
                    </div>
                    <div>
                        <p
                            className={ip.cellPrimary}
                            style={{
                                marginBottom: 2,
                                fontSize: 14,
                                fontWeight: 600,
                                color: "#1e293b",
                            }}
                        >
                            Subject {row.subjectNo || "-"}
                        </p>
                        <p
                            className={ip.cellSecondary}
                            style={{ margin: 0, fontSize: 12, color: "#64748b" }}
                        >
                            Initials: {row.initials || "-"}
                        </p>
                    </div>
                </div>
            );
        },
    },
    {
        key: "checkoutStatus",
        label: "CHECK-OUT STATUS",
        render: (_: any, row?: SubjectRow) => {
            if (!row) return <></>;
            const isCheckedOut = row.checkoutStatus === "checked-out";
            return (
                <CommonStatusBadge
                    isActive={isCheckedOut}
                    activeText="Complete"
                    inactiveText="Pending"
                    activeColor="success"
                    inactiveColor="warning"
                    style={{ width: "90px" }}
                />
            );
        },
    },
    {
        key: "checkoutDate",
        label: "CHECK-OUT DATE & TIME",
        render: (_: any, row?: SubjectRow) => {
            if (!row) return <></>;
            if (row.checkoutStatus !== "pending" && row.checkoutDate) {
                return (
                    <>
                        <p className={ip.cellPrimary} style={{ marginBottom: 1 }}>
                            {formatDate(row.checkoutDate)}
                        </p>
                        <p className={ip.cellSecondary}>{formatTime24Hour(row.checkoutTime)}</p>
                    </>
                );
            }
            return (
                <span
                    style={{
                        display: "inline-block",
                        width: "100px",
                        textAlign: "center",
                        color: "#94a3b8",
                        fontWeight: 500,
                    }}
                >
                    --
                </span>
            );
        },
    },
    canassign && {
        key: "id",
        label: "ACTIONS",
        textCenter: true,
        render: (_: any, row?: SubjectRow) => {
            if (!row) return <></>;
            return (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 8,
                    }}
                >
                    {row.checkoutStatus === "pending" ? (
                        <CommonButton
                            module={PERMISSION_MODULES.SUBJECT_CHECKOUT}
                            action={PERMISSION_ACTIONS.CHECK_OUT}
                            color="primary"
                            size="sm"
                            className="px-3"
                            onClick={() => openCheckout(row)}
                            disabled={row.checkinStatus !== "checked-in"}
                            style={{
                                fontSize: 12,
                                fontWeight: 500,
                                borderRadius: 6,
                            }}
                        >
                            Check Out
                        </CommonButton>
                    ) : (
                        <span
                            style={{ fontSize: 12, color: "#15803d", fontWeight: 600 }}
                        >
                            <i className="ri-checkbox-circle-line" /> Completed
                        </span>
                    )}
                </div>
            );
        },
    },
].filter(Boolean);
